import { css, keyframes } from 'styled-components';
var actionPop = function actionPop(_ref) {
  var maxScale = _ref.maxScale;
  return keyframes(["0%{opacity:0;transform:scale(0);}30%{opacity:1;transform:scale(0.8);}50%{transform:scale(", ");}"], maxScale || 1.15);
};
export var animationPop = css(["animation:", " 0.3s ease-in;"], actionPop);